module.exports = __webpack_public_path__ + "img/border-bottom-right.4fde54d0.svg";